import * as React from 'react';
import { Button, Modal, Popconfirm } from 'antd';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { isAdminUser, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import {
	plannedMaintenanceTemplatesRestCrudThunksForBuyer,
	plannedMaintenanceTemplatesRestCrudThunksForSupplier,
} from '../../thunks/planned_maintenance_templates_thunks';
import { plannedMaintenanceFrequencyTextFormatter } from '../../utils/DataFormatterUtils';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import {
	getBackLinkStates,
	getLinkWIthBackLinkParams,
	safeEncodeURIComponent,
} from '../../utils/HistoryUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import { plannedMaintenanceScheduleNow } from '../../thunks/planned_maintenance_schedules_thunks';
import { ClockCircleOutlined, LayoutOutlined } from '@ant-design/icons';

require('./PlannedMaintenanceSchedulesDetailPage.less');

const DEFAULT_BACK_TEXT = 'Back to PM Schedules';

const queryString = require('qs');

class PlannedMaintenanceSchedulesDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		const defaultBackLinkTo = `/${props.userType}/plannedMaintenance/overview/all`;
		const backLinkStates = getBackLinkStates(props.location, defaultBackLinkTo);
		this.state = {
			backLinkTo: backLinkStates.backLinkTo || defaultBackLinkTo,
			backLinkText: backLinkStates.backLinkText || DEFAULT_BACK_TEXT,
		};
	}
	componentDidMount() {
		const { getPlannedMaintenanceTemplate, match } = this.props;
		const plannedMaintenanceTemplateId = match.params.plannedMaintenanceTemplateId;
		getPlannedMaintenanceTemplate(plannedMaintenanceTemplateId);
	}

	handleTabChange = (key) => {
		const { history, match, userType } = this.props;
		const plannedMaintenanceScheduleId = match.params.id;
		history.push(`/${userType}/plannedMaintenance/detail/${plannedMaintenanceScheduleId}/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	handleDelete = () => {
		const { history, deletePlannedMaintenanceSchedule, plannedMaintenanceSchedule, userType } =
			this.props;
		deletePlannedMaintenanceSchedule(plannedMaintenanceSchedule).then(() => {
			history.push(`/${userType}/plannedMaintenance/overview/all`);
		});
	};
	handleScheduleNow = (e) => {
		const { scheduleNow, history, userType, match, location } = this.props;
		const title = decodeURIComponent(match.params.title);
		const frequency = decodeURIComponent(match.params.frequency);
		const plannedMaintenanceTemplateId = decodeURIComponent(
			match.params.plannedMaintenanceTemplateId
		);
		const basedOn = decodeURIComponent(match.params.basedOn);
		scheduleNow({
			title,
			frequency,
			plannedMaintenanceTemplateId: parseInt(plannedMaintenanceTemplateId, 10),
			basedOn,
		}).then(() => {
			Modal.success({
				title: 'Successfully scheduled.',
				content: (
					<div className="flex flex-col gap-y-2">
						<div className="text-gray-800">The schedule will run in next 30 mins</div>
						<div className="mt-2 flex flex-row gap-x-2 space-y-1 text-gray-500">
							<span className="text-gray-500">
								Please note, there is no change to your existing schedule. If you want to change it,
								<span
									className={`text-${userType} cursor-pointer px-2`}
									onClick={() => {
										history.push(
											getLinkWIthBackLinkParams(
												location,
												DEFAULT_BACK_TEXT,
												`/${userType}/plannedMaintenance/edit/${safeEncodeURIComponent(
													title
												)}/${frequency}/${plannedMaintenanceTemplateId}/${basedOn}`
											)
										);
									}}
								>
									Click here
								</span>
							</span>
						</div>
					</div>
				),
				okText: 'Got it',
			});
		});
	};

	render() {
		const {
			plannedMaintenanceTemplatesFetching,
			plannedMaintenanceTemplate,
			match,
			userType,
			companyConfig,
			currentUser,
			location,
		} = this.props;
		const plannedMaintenanceScheduleTitle = decodeURIComponent(match.params.title);
		const plannedMaintenanceScheduleFrequency = decodeURIComponent(match.params.frequency);
		const plannedMaintenanceTemplateId = decodeURIComponent(
			match.params.plannedMaintenanceTemplateId
		);
		const basedOn = decodeURIComponent(match.params.basedOn);
		const tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
		];

		const editAllowedByRoleAndLocationAccess =
			isAdminUser(currentUser) || currentUser.hasAccessToAllLocations;

		const redirectPath = `/${userType}/plannedMaintenance/detail/${safeEncodeURIComponent(
			plannedMaintenanceScheduleTitle
		)}/${encodeURIComponent(plannedMaintenanceScheduleFrequency)}/${encodeURIComponent(
			plannedMaintenanceTemplateId
		)}/${encodeURIComponent(basedOn)}/details`;

		return (
			<div className="plannedMaintenanceSchedulesDetailPage">
				<Route
					path={`/${userType}/plannedMaintenance/detail/:title/:frequency/:plannedMaintenanceTemplateId/:basedOn`}
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: redirectPath,
								search: props.location.search,
							}}
						/>
					)}
				/>
				<DetailPageHeader
					backLinkText={this.state.backLinkText}
					backLinkTo={this.state.backLinkTo}
					title={plannedMaintenanceScheduleTitle}
					backgroundColor={nullSafeGet('detail.config.theme.navblock', companyConfig)}
					subtitle={
						<div className="flex flex-col justify-start">
							<div className="plannedMaintenanceSchedulesDetailPage__subtitle">
								{plannedMaintenanceFrequencyTextFormatter(plannedMaintenanceScheduleFrequency)}
							</div>
							<div className="plannedMaintenanceSchedulesDetailPage__subtitle">
								{plannedMaintenanceTemplatesFetching ? null : (
									<div>
										<i className="icons8-font icons8-maintenance-filled" />
										<span>
											{' '}
											{nullSafeGet('problemType.hierarchyName', plannedMaintenanceTemplate)}
										</span>
									</div>
								)}
							</div>
							{!plannedMaintenanceTemplatesFetching &&
							nullSafeGet('area.name', plannedMaintenanceTemplate) ? (
								<div className="plannedMaintenanceTemplatesDetailPage__subtitle">
									<LayoutOutlined />
									<span>
										{' '}
										{nullSafeGetOrElse(
											'area.hierarchyName',
											plannedMaintenanceTemplate,
											nullSafeGet('area.name', plannedMaintenanceTemplate)
										)}
									</span>
								</div>
							) : null}
						</div>
					}
					actions={
						editAllowedByRoleAndLocationAccess
							? [
									<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_PM}>
										<Popconfirm
											title={`Are you sure you want to schedule all the scheduled ${basedOn}s now?`}
											onConfirm={this.handleScheduleNow}
											okText="Yes"
											cancelText="No"
										>
											<Button style={{ marginRight: 8 }} ghost icon={<ClockCircleOutlined />}>
												Schedule Now
											</Button>
										</Popconfirm>
									</AccessPermissionChecker>,
									<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_PM}>
										<Link
											key={1}
											to={getLinkWIthBackLinkParams(
												location,
												DEFAULT_BACK_TEXT,
												`/${userType}/plannedMaintenance/edit/${safeEncodeURIComponent(
													plannedMaintenanceScheduleTitle
												)}/${plannedMaintenanceScheduleFrequency}/${plannedMaintenanceTemplateId}/${basedOn}`
											)}
											style={{ marginRight: 16 }}
										>
											<Button ghost={true}>Edit</Button>
										</Link>
									</AccessPermissionChecker>,
							  ]
							: null
					}
					tabs={tabs}
					handleTabChange={this.handleTabChange}
					checkTabActive={this.checkTabActive}
					childRoutes={this.props.childRoutes}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	plannedMaintenanceTemplate: state.planned_maintenance_templates.detail,
	plannedMaintenanceTemplatesFetching: state.planned_maintenance_templates.fetching,
	match: ownProps.match,
	history: ownProps.history,
	userType: (state as any).session.userType,
	companyConfig: state.company_config,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		getPlannedMaintenanceTemplate: (id) =>
			dispatch(
				ownProps.userType === ROLE_TYPES.SUPPLIER
					? plannedMaintenanceTemplatesRestCrudThunksForSupplier.readOne(id)
					: plannedMaintenanceTemplatesRestCrudThunksForBuyer.readOne(id)
			),
		scheduleNow: (entity) => dispatch(plannedMaintenanceScheduleNow(ownProps.userType)(entity)),
	};
};

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(PlannedMaintenanceSchedulesDetailPage)
);
export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
